"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutableSegment = exports.Segment = void 0;
var class_validator_1 = require("class-validator");
var is_not_empty_string_1 = require("../class-validators/is-not-empty-string");
var segment_source_1 = require("../enums/segment-source");
var with_default_value_1 = require("../class-transformers/with-default-value");
var class_transformer_1 = require("class-transformer");
var abstract_struct_1 = require("./abstract-struct");
var case_insensitive_ingest_1 = require("../class-transformers/case-insensitive-ingest");
var segment_type_1 = require("../enums/segment-type");
var segment_builder_1 = require("../builders/segment-builder");
var Segment = (function (_super) {
    __extends(Segment, _super);
    function Segment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Segment, "Builder", {
        get: function () {
            return new segment_builder_1.SegmentBuilder();
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsPositive)(),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Number)
    ], Segment.prototype, "id", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'computed_status' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], Segment.prototype, "computedStatus", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'domain_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsPositive)(),
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], Segment.prototype, "domainId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Segment.prototype, "name", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsEnum)(segment_source_1.SegmentSource),
        __metadata("design:type", String)
    ], Segment.prototype, "source", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'is_default' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsBoolean)(),
        __metadata("design:type", Boolean)
    ], Segment.prototype, "isDefault", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'topic_name' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], Segment.prototype, "topicName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'icon_url' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Segment.prototype, "iconUrl", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'filters_json' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        __metadata("design:type", Object)
    ], Segment.prototype, "filtersJson", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'treatment_spec' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        __metadata("design:type", Object)
    ], Segment.prototype, "treatmentSpec", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'estimated_reach' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsPositive)(),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Segment.prototype, "estimatedReach", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'last_targeted_date_utc' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsDateString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Date)
    ], Segment.prototype, "lastTargetedDateUtc", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.ArrayUnique)(),
        __metadata("design:type", Array)
    ], Segment.prototype, "channels", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Segment.prototype, "group", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsEnum)(segment_type_1.SegmentType),
        __metadata("design:type", String)
    ], Segment.prototype, "type", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ each: true }),
        (0, class_validator_1.IsArray)(),
        __metadata("design:type", Array)
    ], Segment.prototype, "flags", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'created_at' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsDateString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Date)
    ], Segment.prototype, "createdAt", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'created_by' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.Min)(0),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Number)
    ], Segment.prototype, "createdBy", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'created_by_user_name' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], Segment.prototype, "createdByUserName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'destroyed_at' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsDateString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Date)
    ], Segment.prototype, "destroyedAt", void 0);
    return Segment;
}(abstract_struct_1.AbstractStruct));
exports.Segment = Segment;
exports.MutableSegment = Segment;
//# sourceMappingURL=segment.js.map